import { StoreData } from "./store.data";
import { SyncStatusKey } from "../types/general-types";

export type SyncStatusModelVersion = 2;
export interface SyncStatusStoreModel extends StoreData {
  /**  **Version Number** **/
  v: SyncStatusModelVersion;

  key: SyncStatusKey;
  acId: string;
  err: Error;
}

export const DefaultSyncStatusStoreModel: SyncStatusStoreModel = {
  key: undefined,
  acId: "",
  v: 2,
  err: null,
  dc: "",
  dm: "",
  id: "",
  vid: "",
};
